import { CHANGE_LANGUAGE_SUCCESS } from '@openplatform/store/actionTypes/homepage';

interface IState {
    currentLanguage: 'zh' | 'en';
    platform: any;
}

let browserSystemLanguage = navigator.language.toLowerCase() || 'zh';
if (browserSystemLanguage.startsWith('zh')) {
    browserSystemLanguage = 'zh';
} else {
    browserSystemLanguage = 'en';
}

const initialState = {
    currentLanguage: (localStorage.getItem('curLang') as 'zh' | 'en') || browserSystemLanguage,
    platform: {},
};

export default function i18n(state: IState = initialState, { type, payload }: any) {
    switch (type) {
        case CHANGE_LANGUAGE_SUCCESS:
            if (payload) {
                return { currentLanguage: payload.currentLanguage, platform: payload.data };
            }
            return state;
        // case CHANGE_LANGUAGE:
        //     localStorage.setItem('curLang', payload);
        //     return state;
        default:
            return state;
    }
}
